"use strict";
'use client';

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var React = _interopRequireWildcard(require("react"));
var CheckboxPrimitive = _interopRequireWildcard(require("@radix-ui/react-checkbox"));
var _cn = require("@udecode/cn");
var _icons = require("../icons");
var _jsxRuntime = require("react/jsx-runtime");
var Checkbox = exports.Checkbox = (0, _cn.withRef)(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, ["className"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckboxPrimitive.Root, _objectSpread({
    className: (0, _cn.cn)('peer size-4 shrink-0 rounded-sm border border-primary bg-background ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground', className),
    ref: ref
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckboxPrimitive.Indicator, {
      className: (0, _cn.cn)('flex items-center justify-center text-current'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Icons.check, {
        className: "size-4"
      })
    })
  }));
});